import {useCollapsibleSidebarContext} from '@github-ui/layout-primitives/CollapsibleSidebar'
import {SidebarTooltip} from '@github-ui/layout-primitives/SidebarTooltip'
import {useRuntimeEnvironment} from '@github-ui/ssr-utils/use-runtime-environment'
import {isStaff} from '@github-ui/stats'
import {CommentIcon} from '@primer/octicons-react'
import {Label, NavList} from '@primer/react'
import styles from './CollapsibleFeedbackLink.module.css'

const PUBLIC_FEEDBACK_URL = 'https://gh.io/issues-sidebar-feedback'
const STAFF_FEEDBACK_URL = 'https://gh.io/issues-sidebar-feedback-staff'

/** Util for preventing hydration issues when SSR'ing to capture the correct feedback link */
export function useFeedbackLink() {
  // The staff header is only available during CSR
  const {isBrowser} = useRuntimeEnvironment()
  return isBrowser && isStaff() ? STAFF_FEEDBACK_URL : PUBLIC_FEEDBACK_URL
}

/**
 * Feedback link for the collapsible sidebar footer. Shows a tooltip in
 * condensed mode and a "Preview" badge when expanded. Reads collapse
 * state from `CollapsibleSidebarContext` so the DOM tree stays stable
 * during CSS transitions.
 */
export function CollapsibleFeedbackLink() {
  const {visualIsExpanded} = useCollapsibleSidebarContext()
  const feedbackUrl = useFeedbackLink()

  const content = (
    <NavList aria-label="Feedback" className={styles.feedbackLinkWrapper}>
      <NavList.Item href={feedbackUrl} target="_blank" rel="noopener noreferrer">
        <NavList.LeadingVisual>
          <CommentIcon />
        </NavList.LeadingVisual>
        Feedback
        <NavList.TrailingVisual>
          <Label variant="success">Preview</Label>
        </NavList.TrailingVisual>
      </NavList.Item>
    </NavList>
  )

  if (visualIsExpanded) return content

  return <SidebarTooltip text="Feedback">{content}</SidebarTooltip>
}
